import { render, staticRenderFns } from "./TastingAnswer.vue?vue&type=template&id=e1fcc9f4&scoped=true&"
import script from "./TastingAnswer.vue?vue&type=script&lang=js&"
export * from "./TastingAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TastingAnswer.vue?vue&type=style&index=0&id=e1fcc9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fcc9f4",
  null
  
)

export default component.exports